export enum OperatorClassEnum {
  MANAGER = 'GERENCIA',
  CASHIER = 'CAIXA',
}

export enum OperatorTypeEnum {
  CASHIER = 'CAIXA',
  MANAGER = 'GERENTE',
}

export enum UserResponsibleTypeEnum {
  ACCESSOR = 'Assessor',
  ACCESSOR_ALT = 'Acessor',
  LEADER = 'Líder',
  ADMIN = 'Admin',
  MANAGER = 'Gerente',
}
